// Typelizer digest ce038bbda6b7b4fadd5c8f4133ea536b
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /educators/invitations/:invitation_id/response/accept */
  accept: (
    params: { invitationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/invitations/:invitation_id/response/accept', params, options),
    method: 'get',
  }),

  /** GET /educators/invitations/:invitation_id/response/reject */
  reject: (
    params: { invitationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/invitations/:invitation_id/response/reject', params, options),
    method: 'get',
  }),

  /** GET /educators/invitations/:invitation_id/response/new */
  new: (
    params: { invitationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/invitations/:invitation_id/response/new', params, options),
    method: 'get',
  }),

  /** GET /educators/invitations/:invitation_id/response */
  show: (
    params: { invitationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/invitations/:invitation_id/response', params, options),
    method: 'get',
  }),

  /** POST /educators/invitations/:invitation_id/response */
  create: (
    params: { invitationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/invitations/:invitation_id/response', params, options),
    method: 'post',
  }),
}
